/**
 * Created by yangxx on 2017/8/23.
 * 基础资源工具类，【一张图内部使用】
 * 用于工程中对资源的获取，加载等方面。
 * 包括获取工程中控件、模块、公共资源的目录的方法；
 * 包括加载css的方法；
 */
'use strict';
define([],function(){
    /**
     *
     * @type {{dev: number, run: number}}
     */
    var MODES={
        APIDEV:'api_dev',//一张图api中的开发
        DEV:'dev',//一张图app开发
        PRO:'pro',//一张图在项目中使用
    }
    /**
     * ResourceUtil
     * @namespace
     */
    var util={};

    /**
     * 获取一张图资源的相对目录
     * @returns {string} -返回对应目录
     * @private
     */
    util._getRelative=function(){
        var paths={};
        paths[MODES.DEV]=util.getBasePath();
        paths[MODES.APIDEV]=util.getBasePath();
        paths[MODES.PRO]=util.getBasePath()+'/deps/tsemap';
        return paths[util._getMode()];
    }
    /**
     * 目录字符串
     * @returns {*|string} -目录字符串
     * @private
     */
    util._getMode=function(){
        return window['devMode']||MODES.PRO;
    }
    /**
     * 获取根目录路径
     * @method
     * @returns {String} 根目录路径
     */
    util.getBasePath=function(){
        var base=window['webApp'];
        if(base&&base.lastIndexOf('/')!=base.length-1){
            base+='/';
        }
        return base;
    }
    /**
     * 获取公共资源目录
     * @method
     * @returns {String} -公共资源目录
     */
    util.getStaticPath=function(){
        return util._getRelative()+'resources/static/';
    }

    /**
     * 获取一张图第三方库位置
     * @returns {*}
     */
    util.getLibPath=function(){
        var paths={};
        paths[MODES.APIDEV]=util._getRelative()+'deps/emaplib';
        paths[MODES.DEV]=paths[MODES.APIDEV];
        paths[MODES.PRO]=util._getRelative()+'deps/lib';
        return paths[util._getMode()];
    }

    //根据配置的key获取路径
    util._getRequireJsPath=function(key,ctx){
        if(window['require']){
            var contexts=requirejs.s.contexts;
            var path=null;
            for(var ctxKey in contexts){
                if(ctx&&(ctx!=ctxKey)){
                    continue;
                }
                var context=contexts[ctxKey];
                if(context.config.paths.hasOwnProperty(key)){
                    path=context.nameToUrl(key);
                    break;
                }
            }
            return path;
        }else{
            throw new Error('requirejs未引入！');
        }
    }

    /**
     *
     * @param key  模块名或者控件名
     * @returns {*}
     * @private
     */
    util._extractCtrlModulePath=function(key){
        try{
            //根据控件js文件require配置获取控件的相对目录
            var path= util._getRequireJsPath(key);
            if(path==null){//没有require配置
                if(key.indexOf('Ctrl')+'Ctrl'.length==key.length){//是控件
                    //根据打包的tsemap.js
                    path=util.getRelativePath()+'controls/'+key+'/js/'+key+'.js';
                }
            }
            var regexStr='^(.*)\/[^\/]+\/'+key+'\.js$';
            var regex=new RegExp(regexStr);
            if(regex.test(path)){
                var str=new RegExp(regexStr).exec(path)[1]+'/';
                return str;
            }else{
                return null;
            }
        }catch(e){}
    }

    /**
     * 获取控件的目录
     * @method
     * @param {String} control - 必填，控件名称，必须与控件类文件名一致，且与require path配置的key一致
     * @returns {String}
     */
    util.getControlPath=function(control){
        return util._extractCtrlModulePath(control);
    }
    /**
     * 获取模块的目录
     * @method
     * @param {String} module - 必填，模块名称，必须与模块类文件名一致，且与require path配置的key一致
     * @returns {String}
     */
    util.getModulePath=function(module){
        return util._extractCtrlModulePath(module);
    }
    /***
     * 获取一张图ui组件的目录
     * @method
     * @param {String} uiName - 必填，ui名称
     * @returns {String}
     */
    util.getUiPath=function(uiName){
        var relative='';
        if(util._getMode()==MODES.APIDEV){
            relative=util.getBasePath()+'/src/ui/'+uiName;
        }else{
            relative=util.getBasePath()+'/deps/tsemap/ui/'+uiName;
        }
        return relative;
    }
    /**
     * 加载样式
     * @method
     * @param {Array} cssArr - 必填，css文件路径的数组
     */
    util.loadCss=function(cssArr){
        var head=document.getElementsByTagName('head')[0];
        if(Object.prototype.toString.call(cssArr)=='[object Array]'){
            //需要考虑样式文件去重，如果已经加载则跳过
            for(var i=0,len=cssArr.length;i<len;i++){
                var css=cssArr[i];
                if(filter(css)){
                    continue;
                }
                var link=document.createElement('link');
                link.setAttribute('href',css);
                link.setAttribute('rel','stylesheet');
                link.setAttribute('type','text/css');
                head.appendChild(link);
            }
        }
        //过滤已有的样式
        function filter(url){
            var links=jQuery('link').filter(function(){
                return jQuery(this).attr('rel')=='stylesheet'
            });
            if(Object.prototype.toString.call(url)=='[object String]'){
                url=handleUrl(url);
                if(url==null){
                    return true;
                }
                for(var i=0,len=links.length;i<len;i++){
                    var link=links.eq(i);
                    if(handleUrl(link.attr('href'))==url){
                        return true;
                    }
                }
                return false;
            }else{
                return true;
            }
        }
        //处理url，用于比较
        function handleUrl(url){
            var regex=/^(.*\.css)(\?.*)?$/;
            if(Object.prototype.toString.call(url)=='[object String]'&&
                regex.test(url)){
                url=regex.exec(url)[1];
                return url.trim().replace(/\/\//g,'/').replace(/\\/g,'/');
            }else{
                return null;
            }
        }


    }

    /***
     * 获取国际化的值
     * @method
     * @param key {String} 必填
     * @returns {Object}
     */
    util.getLocaleValue=function(key){
        var value=getLocale('app_local',key)||getLocale('tsemap_local',key);
        return value;
        //
        function getLocale(locale,key){
            var value=null;
            try{
                var gLocale=window['baseLocal'][locale];
                if(gLocale){
                    if(typeof key =='string'){
                        var arr=key.split('.'),
                            i=0;
                        value=gLocale;
                        while(value&&i<arr.length){
                            value=value[arr[i]];
                            i++;
                        }
                    }
                }
            }catch(e){
                value=null;
            }
            value=value||null;
            return value;
        }
    }

    /***
     * 获取tsemap.js(sdk打包文件)在服务器上的目录
     * @method
     * @returns {String}
     */
    util.getRelativePath=function(){
        var tsemapReg = /[\/^]tsemap[\-\._]?([\w\-\._]*)\.js\??/;
        return util._getScriptPath(tsemapReg);
    }

    //
    util._getScriptPath=function(regex){
        var scripts = document.getElementsByTagName('script');
        var i, len, src, matches, path;
        var path=null;
        for (i = 0, len = scripts.length; i < len; i++) {
            src = scripts[i].src;
            matches = src.match(regex);

            if (matches) {
                path = src.split(regex)[0];
                path= path ? path + '/' : '';
            }
        }
        return path;
    }
    return util;
});
